import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AppUseSelector } from '../../redux/hooks'
import { updateAutoMasteryUpdates } from '../../redux/actions/wordsAction'
import NotificationBox from '../../containers/form/NotificationBox'
import { SettingsOption, SettingsSection } from './SettingsSection'

const WordMasterySection = ({ id }: { id?: string }) => {
  const { t } = useTranslation('settings')
  const { auto_mastery_updates } = AppUseSelector(({ words }) => words)
  const [isUpdating, setIsUpdating] = useState(false)
  const [notify, setNotify] = useState({ label: '', isError: false })

  const clearNotify = () => setNotify({ label: '', isError: false })

  const handleToggle = async () => {
    if (isUpdating) return
    clearNotify()
    setIsUpdating(true)
    try {
      await updateAutoMasteryUpdates(!auto_mastery_updates)
      setNotify({ label: t('wordMastery.saved'), isError: false })
    } catch {
      setNotify({ label: t('wordMastery.saveError'), isError: true })
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <SettingsSection id={id} title={t('wordMastery.title')}>
      <NotificationBox clearNotify={clearNotify} {...notify} />
      <SettingsOption
        type='checkbox'
        label={t('wordMastery.auto')}
        description={t('wordMastery.autoDescription')}
        checked={!!auto_mastery_updates}
        disabled={isUpdating}
        onChange={handleToggle}
      />
    </SettingsSection>
  )
}

export default WordMasterySection
